import { Dayjs } from "dayjs";
import { FolderSummary, PartialBlob } from "../types";
import { isBlobArchived, isBlobDeleted } from "./blob-status";

export type BlobStatusFilter = "all" | "available" | "archived" | "deleted";

export const filterFoldersByName = (
  folders: FolderSummary[],
  query: string,
): FolderSummary[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return folders;
  return folders.filter((folder) =>
    folder.name.toLowerCase().includes(normalized),
  );
};

export const filterBlobsByName = (
  blobs: PartialBlob[],
  query: string,
): PartialBlob[] => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return blobs;
  return blobs.filter((blob) => blob.name.toLowerCase().includes(normalized));
};

export const filterBlobsByCreatedDateRange = (
  blobs: PartialBlob[],
  from: Dayjs | null,
  to: Dayjs | null,
): PartialBlob[] => {
  if (!from && !to) return blobs;

  const fromMs = from ? from.startOf("day").valueOf() : null;
  const toMs = to ? to.endOf("day").valueOf() : null;

  return blobs.filter((blob) => {
    const createdOn = blob.blobModifiedInformation?.createdOn;
    if (!createdOn) return false;

    const createdMs = new Date(createdOn).getTime();
    if (fromMs !== null && createdMs < fromMs) return false;
    if (toMs !== null && createdMs > toMs) return false;
    return true;
  });
};

export const filterBlobsByStatus = (
  blobs: PartialBlob[],
  statusFilter: BlobStatusFilter,
): PartialBlob[] => {
  if (statusFilter === "all") return blobs;

  return blobs.filter((blob) => {
    const deleted = isBlobDeleted(blob);
    if (statusFilter === "deleted") return deleted;
    if (deleted) return false;

    return statusFilter === "archived"
      ? isBlobArchived(blob)
      : !isBlobArchived(blob);
  });
};
